import { ReactNode } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Footer from "./footer";
import Navbar from "./navbar";

type Props = {
  children?: ReactNode;
};

const Layout = ({ children }: Props) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <main className="flex-grow flex flex-col bg-blue-50 pb-4">
        <Navbar />
        {children}
        <Footer />
      </main>
    </DndProvider>
  );
};

export default Layout;
